export const defaultForbiddenPatterns = [
  /(^|\s)sudo\s+rm\b/i,
  /\brm\s+--no-preserve-root/i,
  /\brm\s+-[^\n]*[rf][^\n]*/i,
  /:\(\)\{:\|:&\};:/,
  /\bshutdown\b/i,
  /\bpoweroff\b/i,
  /\bhalt\b/i,
  /\bmkfs(\.|\s)/i,
  /\bdd\b[^\n]*\bof=\/dev\/(sd[a-z]\d*|nvme\w+)/i,
  /\bchmod\s+-R\s+777\s+\//i,
  /\bchown\s+-R\s+\S+\s+\//i,
  /\b(curl|wget)[^\n]*\|\s*(sh|bash)\b/i,
  /\bkill\s+-9\s+1\b/i,
  /\bpkill\s+-9\b/i,
  /\bformat\s+c:\\?/i,
  /\bdel\s+\/(q|f|s)/i,
  /\brd\s+\/s\s+\/q\s+c:\\?/i,
];

export const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export function buildForbiddenPatterns(extraPatterns) {
  const extra = Array.isArray(extraPatterns) ? extraPatterns : [];
  const compiled = extra
    .map((item) => {
      if (!item) return null;
      if (item instanceof RegExp) return item;
      if (typeof item === 'string') {
        return new RegExp(`^\\s*${escapeRegExp(item)}(\\s|$)`, 'i');
      }
      return null;
    })
    .filter(Boolean);
  return [...defaultForbiddenPatterns, ...compiled];
}

export function isCommandForbidden(cmd, patterns) {
  if (!cmd) return false;
  const list = Array.isArray(patterns) ? patterns : defaultForbiddenPatterns;
  return list.some((re) => re.test(cmd));
}
